/**
 *
 * Asynchronously loads the component for VerifyOtp
 *
 */

import { lazyLoad } from 'utils/loadable';

export const VerifyOtp = lazyLoad(
  () => import('./index'),
  module => module.VerifyOtp,
);
